<div class="new-item-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{ translationFileSection + '.modal-new-item-title' | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body">
    <div class="fw-bold message pe-3">
      <div>
        {{ translationFileSection + '.modal-new-item-sub-title' | translate }}
      </div>
    </div>
  </div>
  <div class="input-name">
    <div class="input-container">
      <input
        #checkIfExistingInput
        autocomplete="off"
        type="text"
        data-cy="modal-name-input"
        class=""
        [formControl]="newItemNameForm"
        [value]="newItemNameForm.value"
        maxlength="40"
        (keyup.enter)="createItem()"
      />
    </div>
    @if (newItemNameForm.dirty && (f?.errors || displayAlreadyExists || displayNameNotAllowed)) {
      <div class="error-container d-flex align-items-baseline">
        @if (f?.errors || displayAlreadyExists || displayNameNotAllowed) {
          <div class="error-icon">
            <img src="../../../assets/images/icon-alert-triangle.svg" alt="error-icon" />
          </div>
        }
        @if (f?.errors?.['required']) {
          <div class="error-text">
            {{ translationFileSection + '.modal-new-item-error-required' | translate }}
          </div>
        }
        @if (f?.errors?.['maxlength']) {
          <div class="error-text">
            {{ translationFileSection + '.modal-new-item-error-maxlength' | translate }}
          </div>
        }
        @if (submitted && !f?.errors?.['required'] && displayAlreadyExists) {
          <div class="error-text">
            {{ translationFileSection + '.modal-new-item-error-existing-name' | translate }}
          </div>
        }
        @if (submitted && !f?.errors?.['required'] && displayNameNotAllowed) {
          <div class="error-text" [innerHTML]="translationFileSection + '.modal-new-item-error-not-allowed-name' | translate"></div>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="cancel fw-bold" (click)="dismissModal(); submitted = false">
      {{ translationFileSection + '.modal-new-item-cancellation' | translate }}
    </button>
    <button [disabled]="f.errors" type="button" class="btn confirm-delete d-flex" (click)="createItem()">
      <span class="text-uppercase fw-bold align-self-center">{{ translationFileSection + '.modal-new-item-validation' | translate }}</span>
    </button>
  </div>
</div>
